import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { environment } from "../environments/environment";
import { AuthService } from 'src/app/_services/auth.service';
import { ConfigService } from 'src/app/_services/config.service';
import { NotificationAlertComponent } from './shared/notification-alert/notification-alert.component';
import { onBackgroundMessage } from "firebase/messaging/sw";
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {

  title = 'admin-panel';
  showSidebar: boolean = false;
  showNavbar: boolean = false;
  showFooter: boolean = false;
  isLoading: boolean = false;
  authClass: boolean = false;

  deviceInfo = {
    browser: "",
    browser_version: "",
    device: "",
    deviceType: "",
    orientation: "",
    os: "",
    os_version: "",
    userAgent: ""
  };

  constructor(
    private _router: Router,
    private _deviceService: DeviceDetectorService,
    private _authService: AuthService,
    private _configService: ConfigService,
    private dialogRef: MatDialog,
  ) {
    this.deviceInfo = this._deviceService.getDeviceInfo();
    this.requestNotificationPermission();

    this._authService.accessTokenObservable.subscribe(accessToken => {
      if (accessToken) {
        this.showSidebar = true;
        this.showNavbar = true;
        this.showFooter = true;
        this.authClass = true;
        this._configService.get().subscribe();
        this.registerDevice();
      } else {
        this.showSidebar = false;
        this.showNavbar = false;
        this.showFooter = false;
        this.authClass = false;
      }
    });

    // Spinner for lazyload modules
    this._router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }

  ngOnInit() {
    // Profile pictures can 404 (deleted Firebase object, expired Google avatar URL).
    // `error` doesn't bubble, so listen in the capture phase and fall back once.
    document.addEventListener('error', (event: Event) => {
      const img = event.target as HTMLImageElement;
      if (img?.tagName === 'IMG' && img.matches('.tbleimg, .iq-top-navbar img.rounded, app-profile img.imagePreview, .bookingdetailcustomer .profileimage img') && !img.dataset['fallback']) {
        img.dataset['fallback'] = '1';
        img.src = 'assets/images_v2/dummyProfile.png';
      }
    }, true);

    this._authService.deviceId = `${this.deviceInfo.os_version}-${this.deviceInfo.deviceType}-${this.deviceInfo.browser}-${this.deviceInfo.browser_version}`;

    // Scroll to top after route change
    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      let top = document.getElementById('scrollToTop');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }
      // Close the off-canvas sidebar after navigating on small screens
      if (window.innerWidth <= 1299) {
        this.closeSidebar();
      }
    });
  }

  // The sidebar is an off-canvas drawer up to 1299px. Its open state is the
  // `sidebar-main` class on <body>, toggled by `.wrapper-menu` in assets/js/custom.js.
  closeSidebar(): void {
    document.body.classList.remove('sidebar-main');
    document.querySelector('.wrapper-menu')?.classList.remove('open');
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeSidebar();
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 1299) {
      this.closeSidebar();
    }
  }

  requestNotificationPermission() {
    try {
      const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebase.vapidKey}).then((fcmToken) => {
      this._authService.fcmToken = fcmToken;
      this.registerDevice();
    }).catch((errorResponse: any) => {});
    } catch (error) {
    }
  }

  registerDevice() {
    if(this._authService.accessToken && this._authService.deviceId && this._authService.fcmToken) {
      this._authService.fcm({ deviceId: this._authService.deviceId, fcm: this._authService.fcmToken }).subscribe();
    }
  }

}
